<template>
  <div class="simple-report-page">
    <div class="report-header">
      <h1 class="main-title">立足人口变化趋势，优化教育资源配置</h1>
      <div class="subtitle">玉溪市人口变化与教育资源配置情况报告</div>
    </div>

    <div class="report-content">
      <!-- 出生人数部分 -->
      <div class="section">
        <div class="section-header">
          <span class="section-number">一、</span>
          <h2 class="section-title">出生人数</h2>
        </div>
        <div class="text-content">
          <p class="highlight-paragraph">
            玉溪市 2010-2030 年出生人口从 2010 年的
            <span class="highlight-text">22935 人</span>
            波动变化，
            <span class="highlight-text important">2017年达到峰值 30536 人</span>
            后持续回落，
            <span class="highlight-text key-point">2030 年预计降至 14881 人</span>
            。
          </p>
        </div>
      </div>

      <!-- 学校数部分 -->
      <div class="section">
        <div class="section-header">
          <span class="section-number">二、</span>
          <h2 class="section-title">学校数</h2>
        </div>
        <div class="text-content">
          <p>
            适应出生人口的变化，各学段学校进行撤并调整，
            <span class="highlight-period">2025 年到 2030 年</span>
            ：
          </p>
          <ul class="school-list">
            <li>
              <span class="school-type">幼儿园</span>
              从
              <span class="number">508个</span>
              减至
              <span class="number decrease">420个,</span>
              <span class="school-type">减少88所, 减幅17.3%</span>
            </li>
            <li>
              <span class="school-type">小学</span>
              从
              <span class="number">410 所</span>
              减至
              <span class="number decrease">315 所,</span>
              <span class="school-type">减少95所, 减幅23.2%</span>
            </li>
            <li>
              <span class="school-type">中学</span>
              从
              <span class="number">85 所</span>
              减至
              <span class="number decrease">76 所,</span>
              <span class="school-type">减少9所, 减幅10.6%</span>
            </li>
            <li>
              <span class="school-type">职中</span>
              从
              <span class="number">13 所</span>
              减至
              <span class="number decrease">12 所,</span>
              <span class="school-type">减少1所, 减幅7.7%</span>
            </li>
            <li>
              <span class="school-type">高中</span>
              从
              <span class="number">22 所</span>
              增到
              <span class="number increase">23 所,</span>
              <span class="school-type">增加1所, 增幅4.5%</span>
            </li>
          </ul>
        </div>
      </div>

      <!-- 各学段招生人数部分 -->
      <div class="section">
        <div class="section-header">
          <span class="section-number">三、</span>
          <h2 class="section-title">各学段招生人数</h2>
        </div>
        <div class="text-content">
          <div class="subsection">
            <h3 class="subsection-title">• 学前教育</h3>
            <p class="subsection-content">
              入园人数高峰在
              <span class="highlight-year">2020 年</span>
              ，当年达
              <span class="highlight-number">34607 人</span>
              ； 预计到
              <span class="highlight-year">2030 年</span>
              ，新招生人数将降至约
              <span class="highlight-number">16000 人</span>
              。
            </p>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">• 小学教育</h3>
            <p class="subsection-content">
              一年级入学高峰在
              <span class="highlight-year">2023 年</span>
              ，人数为
              <span class="highlight-number">30065 人</span>
              ； 预计到
              <span class="highlight-year">2035 年</span>
              ，一年级招生人数将降至约
              <span class="highlight-number">16000 人</span>
              。
            </p>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">• 初中教育</h3>
            <p class="subsection-content">
              七年级入学人数预计在
              <span class="highlight-year">2029 年</span>
              达峰，约
              <span class="highlight-number">30000 人</span>
              ； 预计到
              <span class="highlight-year">2035年</span>
              ，七年级招生人数将降至约
              <span class="highlight-number">17000 人</span>
              。
            </p>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">• 普通高中</h3>
            <p class="subsection-content">
              入学人数预计在
              <span class="highlight-year">2032 年</span>
              达峰，约
              <span class="highlight-number">21000 人</span>
              ； 预计到
              <span class="highlight-year">2035 年</span>
              ，高一年级招生人数将降至约
              <span class="highlight-number">14000 人</span>
              。
            </p>
          </div>
        </div>
      </div>

      <!-- 各学段在校学生人数部分 -->
      <div class="section">
        <div class="section-header">
          <span class="section-number">四、</span>
          <h2 class="section-title">各学段在校学生人数</h2>
        </div>
        <div class="text-content">
          <div class="subsection">
            <h3 class="subsection-title">• 学前教育</h3>
            <p class="subsection-content">
              在园总人数峰值出现在
              <span class="highlight-year">2022 年</span>
              ，约
              <span class="highlight-number">79412 人</span>
              ； 预计到
              <span class="highlight-year">2035 年</span>
              ，在园幼儿规模将降至约
              <span class="highlight-number">41000 人</span>
              。
            </p>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">• 小学教育</h3>
            <p class="subsection-content">
              在校生规模预计在
              <span class="highlight-year">2025 年</span>
              达峰，约
              <span class="highlight-number">156000 人</span>
              ； 预计到
              <span class="highlight-year">2035 年</span>
              ，在校生规模将降至约
              <span class="highlight-number">110000 人</span>
              。
            </p>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">• 初中教育</h3>
            <p class="subsection-content">
              在校生规模预计在
              <span class="highlight-year">2031 年</span>
              达峰，约
              <span class="highlight-number">83000 人</span>
              ； 预计到
              <span class="highlight-year">2035 年</span>
              ，在校生规模将降至约
              <span class="highlight-number">54000 人</span>
              。
            </p>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">• 普通高中</h3>
            <p class="subsection-content">
              在校生总数预计在
              <span class="highlight-year">2034 年</span>
              达峰，约
              <span class="highlight-number">50000 人</span>
              ； 预计到
              <span class="highlight-year">2035 年</span>
              ，在校生规模将降至约
              <span class="highlight-number">47000 人</span>
              。
            </p>
          </div>
        </div>
      </div>

      <!-- 各学段教师人数部分 -->
      <div class="section">
        <div class="section-header">
          <span class="section-number">五、</span>
          <h2 class="section-title">各学段教师人数</h2>
        </div>
        <div class="text-content">
          <div class="subsection">
            <h3 class="subsection-title">• 幼儿园专任教师</h3>
            <p class="subsection-content">
              2015-2022 年从
              <span class="highlight-number">2442 人</span>
              增至峰值
              <span class="highlight-number important">4517 人</span>
              ， 此后逐年回落，2024年为
              <span class="highlight-number">4024 人</span>
              ， 预计 2035年为
              <span class="highlight-number key-point">2786 人</span>
              。
            </p>
            <p class="note-text">随着适龄儿童数量减少，未来城乡幼儿园将出现教师富余情况。</p>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">• 小学专任教师</h3>
            <p class="subsection-content">
              2015 年为
              <span class="highlight-number">10781 人</span>
              ， 后续整体呈递减趋势，2024 年降至
              <span class="highlight-number">9902 人</span>
              ， 预计 2035 年减少至
              <span class="highlight-number key-point">6650 人</span>
              。
            </p>
            <p class="note-text">
              <span class="note-title">城区小学：</span>
              教师需求高峰在 2025 年，缺口约 120 人，2029 年开始富余；
              <span class="note-title">乡镇小学：</span>
              一直保持教师富余状态。
            </p>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">• 初中专任教师</h3>
            <p class="subsection-content">
              2015-2024 年从
              <span class="highlight-number">6565 人</span>
              缓降至
              <span class="highlight-number">5869 人</span>
              ， 2025-2031 年逐步回升，2031 年达峰值
              <span class="highlight-number important">7034 人</span>
              ， 之后持续下降，预计 2035 年为
              <span class="highlight-number key-point">4584 人</span>
              。
            </p>
            <p class="note-text">
              <span class="note-title">城区初中：</span>
              教师需求高峰在 2031 年，缺口约 700 人，2034 年转为富余；
            </p>
            <p class="note-text">
              <span class="note-title">镇区初中：</span>
              教师需求高峰在 2031 年，缺口约 400 人，2036 年富余约 900 人；
            </p>
            <p class="note-text">
              <span class="note-title">乡村初中：</span>
              整体教师富余约 1000 人。
            </p>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">• 普通高中专任教师</h3>
            <p class="subsection-content">
              2015-2032 年从
              <span class="highlight-number">2650 人</span>
              稳步增长至峰值
              <span class="highlight-number important">4257 人</span>
              ， 2033 年后开始回落，2024 年为
              <span class="highlight-number">3129 人</span>
              ， 预计 2035 年降至
              <span class="highlight-number">3594 人</span>
              。
            </p>
            <p class="note-text">
              <span class="note-title">教师需求：</span>
              高峰在 2034 年，缺口约 900 人，2037 年开始富余；
            </p>
            <p class="note-text important-note">
              <span class="note-title">特别注意：</span>
              2033 年后，部分教学质量欠佳的公办高中及民办高中将面临师资过剩问题。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// 不需要复杂脚本
</script>

<style scoped>
.simple-report-page {
  padding: 24px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
  min-height: 100vh;
  font-family: 'Microsoft YaHei', 'Segoe UI', 'PingFang SC', sans-serif;
}

.report-header {
  text-align: center;
  margin-bottom: 40px;
  padding: 30px 20px;
  background: linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%);
  border-radius: 12px;
  color: white;
  box-shadow: 0 8px 25px rgba(26, 115, 232, 0.3);
}

.main-title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 12px;
  line-height: 1.3;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
}

.subtitle {
  font-size: 18px;
  opacity: 0.9;
  font-weight: 400;
}

.report-content {
  max-width: 80%;
  margin: 0 auto;
}

.section {
  background: white;
  border-radius: 10px;
  padding: 30px;
  margin-bottom: 30px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  border-left: 5px solid #1a73e8;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.section:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;
}

.section-number {
  font-size: 28px;
  font-weight: 700;
  color: #1a73e8;
  margin-right: 10px;
}

.section-title {
  font-size: 26px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.text-content {
  font-size: 18px;
  line-height: 1.8;
  color: #444;
}

.highlight-paragraph {
  font-size: 20px;
  line-height: 1.8;
  margin-bottom: 20px;
  color: #333;
}

.highlight-text {
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
}

.highlight-text.important {
  color: #d32f2f;
  background-color: #ffebee;
}

.highlight-text.key-point {
  color: #388e3c;
  background-color: #e8f5e9;
}

.highlight-period {
  font-weight: 700;
  color: #7b1fa2;
  background-color: #f3e5f5;
  padding: 2px 8px;
  border-radius: 4px;
}

.school-list {
  list-style: none;
  padding: 0;
  margin: 20px 0;
}

.school-list li {
  padding: 12px 15px;
  margin-bottom: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 4px solid #1a73e8;
  font-size: 18px;
  line-height: 1.6;
}

.school-type {
  font-weight: 600;
  color: #1a73e8;
  margin-right: 8px;
}

.number {
  font-weight: 600;
  color: #555;
}

.number.decrease {
  color: #d32f2f;
  font-weight: 700;
}

.number.increase {
  color: #388e3c;
  font-weight: 700;
}

.subsection {
  margin-bottom: 25px;
  padding-bottom: 20px;
  border-bottom: 1px dashed #e0e0e0;
}

.subsection:last-child {
  border-bottom: none;
}

.subsection-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
  padding-left: 10px;
  border-left: 4px solid #4caf50;
}

.subsection-content {
  font-size: 18px;
  line-height: 1.7;
  color: #444;
  padding-left: 14px;
}

.highlight-year {
  font-weight: 700;
  color: #7b1fa2;
  background-color: #f3e5f5;
  padding: 1px 6px;
  border-radius: 3px;
}

.highlight-number {
  font-weight: 700;
  color: #1a73e8;
  background-color: #e8f0fe;
  padding: 1px 6px;
  border-radius: 3px;
}

.note-text {
  font-size: 17px;
  line-height: 1.6;
  color: #666;
  background: #f9f9f9;
  padding: 12px 15px;
  border-radius: 6px;
  margin-top: 12px;
  border-left: 3px solid #ff9800;
}

.note-title {
  font-weight: 600;
  color: #ff9800;
}

.note-text.important-note {
  background: #fff3e0;
  border-left: 3px solid #f57c00;
  font-weight: 500;
}

.note-text.important-note .note-title {
  color: #f57c00;
}

@media (max-width: 768px) {
  .simple-report-page {
    padding: 15px;
  }

  .report-header {
    padding: 20px 15px;
    margin-bottom: 25px;
  }

  .main-title {
    font-size: 26px;
  }

  .section {
    padding: 20px;
    margin-bottom: 20px;
  }

  .section-title {
    font-size: 22px;
  }

  .text-content,
  .subsection-content,
  .highlight-paragraph {
    font-size: 17px;
  }

  .school-list li {
    font-size: 16px;
  }
}
</style>
